import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
import _toConsumableArray from "@babel/runtime/helpers/esm/toConsumableArray";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import React, { useEffect, useState } from 'react';
import Modal from '../../modal/Modal';
import { IoMdClose } from 'react-icons/io';
import ImageLoader from '../../images/ImageLoader';
import { Button } from 'react-bootstrap';
import RewardsRecommendationListing from './RewardsRecommendationListing';
import PegRedemptionCardListing from './PegRedemptionCardListing';
import RewardsUpdatingOverlay from './RewardsUpdatingOverlay';
import RewardSelectionModalError from './RewardSelectionModalError';
import { getSessionStorageKey } from '../../../util/sessionStorage';

var RewardSelectionModal = function RewardSelectionModal(props) {
  var _props$rewardsState2, _props$rewardsState6, _model$RewardValueLa, _model$RewardValueLa$;

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      configChanged = _useState2[0],
      setConfigChanged = _useState2[1];

  var _useState3 = useState([]),
      _useState4 = _slicedToArray(_useState3, 2),
      bonusRewards = _useState4[0],
      setBonusRewards = _useState4[1];

  var _useState5 = useState(false),
      _useState6 = _slicedToArray(_useState5, 2),
      showOverlay = _useState6[0],
      setShowOverlay = _useState6[1];

  var _useState7 = useState({
    show: false,
    action: null
  }),
      _useState8 = _slicedToArray(_useState7, 2),
      errorState = _useState8[0],
      setErrorState = _useState8[1];

  var _useState9 = useState(null),
      _useState10 = _slicedToArray(_useState9, 2),
      selectedValues = _useState10[0],
      setSelectedValues = _useState10[1];

  var _useState11 = useState(0),
      _useState12 = _slicedToArray(_useState11, 2),
      rewardsValue = _useState12[0],
      setRewardsValue = _useState12[1];

  var _useState13 = useState([]),
      _useState14 = _slicedToArray(_useState13, 2),
      availableRewards = _useState14[0],
      setAvailableRewards = _useState14[1];

  var _useState15 = useState(0),
      _useState16 = _slicedToArray(_useState15, 2),
      availablePegRewards = _useState16[0],
      setAvailablePegRewards = _useState16[1];

  var _props$model = props.model,
      model = _props$model === void 0 ? {} : _props$model,
      show = props.show,
      hide = props.hide,
      moduleType = props.moduleType,
      setModuleType = props.setModuleType,
      getRedeemedRewardsList = props.getRedeemedRewardsList,
      releaseRedemptionEngineV2 = props.releaseRedemptionEngineV2,
      _props$rewardBadge = props.rewardBadge,
      rewardBadge = _props$rewardBadge === void 0 ? null : _props$rewardBadge,
      _props$unavailableRew = props.unavailableRewardCopy,
      unavailableRewardCopy = _props$unavailableRew === void 0 ? null : _props$unavailableRew;
  var Logo = model.Logo,
      RecomendationListing = model.RecomendationListing,
      PegRedemptionCardsList = model.PegRedemptionCardsList,
      ApplyButton = model.ApplyButton,
      RefreshLabel = model.RefreshLabel,
      Copy = model.Copy,
      Description = model.Description,
      Header = model.Header,
      RetryButton = model.RetryButton;
  var errorModel = {
    Copy: Copy,
    Description: Description,
    Header: Header,
    RetryButton: RetryButton
  };
  /**
   * Handle refresh button click
   * @returns {Promise<void>}
   */

  var handleRefresh = /*#__PURE__*/function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      var _selectedValues$rewar, _customRewardRedempti, _customRewardRedempti2, rewardsIds, customRewardRedemption, totalDiscountAmount, _customRewardRedempti3, _customRewardRedempti4;

      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.prev = 0;
              setShowOverlay(true);
              rewardsIds = selectedValues === null || selectedValues === void 0 ? void 0 : (_selectedValues$rewar = selectedValues.rewards) === null || _selectedValues$rewar === void 0 ? void 0 : _selectedValues$rewar.map(function (reward) {
                if (releaseRedemptionEngineV2) {
                  return {
                    "rewardId": reward.id,
                    "couponCode": reward.code,
                    "expirationDate": reward.expiration
                  };
                } else {
                  return reward.id;
                }
              });
              _context.next = 5;
              return props.rewardsRedemption(rewardsIds || [], (selectedValues === null || selectedValues === void 0 ? void 0 : selectedValues.pegs) || '0', '', null, releaseRedemptionEngineV2);

            case 5:
              customRewardRedemption = _context.sent;
              totalDiscountAmount = (customRewardRedemption === null || customRewardRedemption === void 0 ? void 0 : (_customRewardRedempti = customRewardRedemption.redeemOptions) === null || _customRewardRedempti === void 0 ? void 0 : (_customRewardRedempti2 = _customRewardRedempti[0]) === null || _customRewardRedempti2 === void 0 ? void 0 : _customRewardRedempti2.totalDiscountAmount) || 0;

              if (releaseRedemptionEngineV2) {
                totalDiscountAmount = (customRewardRedemption === null || customRewardRedemption === void 0 ? void 0 : (_customRewardRedempti3 = customRewardRedemption.redeemOptions) === null || _customRewardRedempti3 === void 0 ? void 0 : (_customRewardRedempti4 = _customRewardRedempti3[0]) === null || _customRewardRedempti4 === void 0 ? void 0 : _customRewardRedempti4.totalDiscountAmt) || 0;
              }

              setRewardsValue(totalDiscountAmount);
              setShowOverlay(false);
              setConfigChanged(false);
              _context.next = 18;
              break;

            case 13:
              _context.prev = 13;
              _context.t0 = _context["catch"](0);
              console.error('error', _context.t0.message);
              setShowOverlay(false);
              setErrorState({
                show: true,
                action: 'refresh'
              });

            case 18:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[0, 13]]);
    }));

    return function handleRefresh() {
      return _ref.apply(this, arguments);
    };
  }();
  /**
   * Handle apply button click
   * @returns {Promise<void>}
   */


  var handleApplyRewards = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
      var _selectedValues$rewar2, applyRewardsResponse, _selectedValues$rewar3, _customRewardRedempti5, _customRewardRedempti6, rewardsIds, customRewardRedemption, totalDiscountAmount, _customRewardRedempti7, _customRewardRedempti8, redeemedRewards, _applyRewardsResponse;

      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _context2.prev = 0;
              setShowOverlay(true);

              if (!(!(selectedValues === null || selectedValues === void 0 ? void 0 : (_selectedValues$rewar2 = selectedValues.rewards) === null || _selectedValues$rewar2 === void 0 ? void 0 : _selectedValues$rewar2.length) && !(selectedValues === null || selectedValues === void 0 ? void 0 : selectedValues.pegs))) {
                _context2.next = 17;
                break;
              }

              setRewardsValue(0);
              _context2.next = 6;
              return props.resetRewardsRedemptionModule();

            case 6:
              _context2.next = 8;
              return props.applyRewards(null);

            case 8:
              applyRewardsResponse = _context2.sent;

              if (!applyRewardsResponse) {
                _context2.next = 13;
                break;
              }

              setModuleType('redeem');
              _context2.next = 13;
              return props.getCart();

            case 13:
              setShowOverlay(false);
              hide();
              _context2.next = 42;
              break;

            case 17:
              rewardsIds = selectedValues === null || selectedValues === void 0 ? void 0 : (_selectedValues$rewar3 = selectedValues.rewards) === null || _selectedValues$rewar3 === void 0 ? void 0 : _selectedValues$rewar3.map(function (reward) {
                if (releaseRedemptionEngineV2) {
                  return {
                    "rewardId": reward.id,
                    "couponCode": reward.code,
                    "expirationDate": reward.expiration
                  };
                } else {
                  return reward.id;
                }
              });
              _context2.next = 20;
              return props.rewardsRedemption(rewardsIds || [], (selectedValues === null || selectedValues === void 0 ? void 0 : selectedValues.pegs) || '0', 'custom', null, releaseRedemptionEngineV2);

            case 20:
              customRewardRedemption = _context2.sent;
              totalDiscountAmount = (customRewardRedemption === null || customRewardRedemption === void 0 ? void 0 : (_customRewardRedempti5 = customRewardRedemption.redeemOptions) === null || _customRewardRedempti5 === void 0 ? void 0 : (_customRewardRedempti6 = _customRewardRedempti5[0]) === null || _customRewardRedempti6 === void 0 ? void 0 : _customRewardRedempti6.totalDiscountAmount) || 0;

              if (releaseRedemptionEngineV2) {
                totalDiscountAmount = (customRewardRedemption === null || customRewardRedemption === void 0 ? void 0 : (_customRewardRedempti7 = customRewardRedemption.redeemOptions) === null || _customRewardRedempti7 === void 0 ? void 0 : (_customRewardRedempti8 = _customRewardRedempti7[0]) === null || _customRewardRedempti8 === void 0 ? void 0 : _customRewardRedempti8.totalDiscountAmt) || 0;
              }

              setRewardsValue(totalDiscountAmount);
              _context2.next = 26;
              return props.redeemRewards('custom', releaseRedemptionEngineV2);

            case 26:
              redeemedRewards = _context2.sent;
              _context2.next = 29;
              return props.applyRewards((redeemedRewards === null || redeemedRewards === void 0 ? void 0 : redeemedRewards.checkout) || null);

            case 29:
              _applyRewardsResponse = _context2.sent;

              if (!_applyRewardsResponse) {
                _context2.next = 38;
                break;
              }

              _context2.next = 33;
              return props.storeRedeemedRewards(redeemedRewards || null);

            case 33:
              _context2.next = 35;
              return getRedeemedRewardsList(redeemedRewards || null, bonusRewards);

            case 35:
              setModuleType('custom');
              _context2.next = 40;
              break;

            case 38:
              _context2.next = 40;
              return props.getCart();

            case 40:
              setShowOverlay(false);
              hide();

            case 42:
              _context2.next = 49;
              break;

            case 44:
              _context2.prev = 44;
              _context2.t0 = _context2["catch"](0);
              console.error('error', _context2.t0.message);
              setShowOverlay(false);
              setErrorState({
                show: true,
                action: 'apply'
              });

            case 49:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2, null, [[0, 44]]);
    }));

    return function handleApplyRewards() {
      return _ref2.apply(this, arguments);
    };
  }();

  useEffect(function () {
    var asyncEffect = /*#__PURE__*/function () {
      var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
        var _bonusRewards, filteredBonusRewards;

        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.prev = 0;
                _context3.next = 3;
                return props.getBonusRewards(releaseRedemptionEngineV2);

              case 3:
                _bonusRewards = _context3.sent;
                filteredBonusRewards = _bonusRewards === null || _bonusRewards === void 0 ? void 0 : _bonusRewards.filter(function (reward) {
                  var _reward$fields, _reward$fields$Extern, _reward$fields2, _reward$fields2$Exter, _reward$fields3, _reward$fields3$Code;

                  return ((_reward$fields = reward.fields) === null || _reward$fields === void 0 ? void 0 : (_reward$fields$Extern = _reward$fields.ExternalId) === null || _reward$fields$Extern === void 0 ? void 0 : _reward$fields$Extern.value) && ((_reward$fields2 = reward.fields) === null || _reward$fields2 === void 0 ? void 0 : (_reward$fields2$Exter = _reward$fields2.ExternalId) === null || _reward$fields2$Exter === void 0 ? void 0 : _reward$fields2$Exter.value) !== '' && ((_reward$fields3 = reward.fields) === null || _reward$fields3 === void 0 ? void 0 : (_reward$fields3$Code = _reward$fields3.Code) === null || _reward$fields3$Code === void 0 ? void 0 : _reward$fields3$Code.value);
                });
                setBonusRewards(filteredBonusRewards);
                _context3.next = 11;
                break;

              case 8:
                _context3.prev = 8;
                _context3.t0 = _context3["catch"](0);
                console.error('error', _context3.t0.message);

              case 11:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, null, [[0, 8]]);
      }));

      return function asyncEffect() {
        return _ref3.apply(this, arguments);
      };
    }();

    asyncEffect();
  }, []);
  useEffect(function () {
    _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4() {
      var _props$cart, _props$cart$cart, productChainIds, rewardsStorage, itemsRewards, availableRewardsAux, _rewardsStorage$recom, _rewardsStorage$recom2, highestDiscountOption, _rewardsStorage$recom3, redeemOptions, allRewardIds, _rewardsStorage$rewar, _rewardsStorage$rewar2, _rewardsStorage$rewar3, _recommendedRewardsRe, _recommendedRewardsRe2, _rewardsStorage$userP, _customRewardRedempti9, _customRewardRedempti10, recommendedRewardsRedemption, recommendedPointsToRedeem, customRewardRedemption, maxPegPointsToRedeem;

      return _regeneratorRuntime.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              if (!show) {
                _context4.next = 27;
                break;
              }

              _context4.prev = 1;
              productChainIds = (_props$cart = props.cart) === null || _props$cart === void 0 ? void 0 : (_props$cart$cart = _props$cart.cart) === null || _props$cart$cart === void 0 ? void 0 : _props$cart$cart.map(function (item) {
                return item.Product.ProductChainId;
              });
              rewardsStorage = getSessionStorageKey("rewards");
              _context4.next = 6;
              return props.getMenuItemPegPoints(productChainIds === null || productChainIds === void 0 ? void 0 : productChainIds.join(','));

            case 6:
              itemsRewards = _context4.sent;
              availableRewardsAux = [];
              itemsRewards === null || itemsRewards === void 0 ? void 0 : itemsRewards.forEach(function (item) {
                availableRewardsAux = [].concat(_toConsumableArray(availableRewardsAux), _toConsumableArray(item.rewardsId));
              });

              if (!releaseRedemptionEngineV2) {
                _context4.next = 14;
                break;
              }

              // Get the option with the highest totalDiscountAmt
              highestDiscountOption = rewardsStorage === null || rewardsStorage === void 0 ? void 0 : (_rewardsStorage$recom = rewardsStorage.recommendedRewardsRedemptionResponse) === null || _rewardsStorage$recom === void 0 ? void 0 : (_rewardsStorage$recom2 = _rewardsStorage$recom.redeemOptions) === null || _rewardsStorage$recom2 === void 0 ? void 0 : _rewardsStorage$recom2.reduce(function (max, current) {
                return current.totalDiscountAmt > max.totalDiscountAmt ? current : max;
              });

              if (highestDiscountOption) {
                redeemOptions = (rewardsStorage === null || rewardsStorage === void 0 ? void 0 : (_rewardsStorage$recom3 = rewardsStorage.recommendedRewardsRedemptionResponse) === null || _rewardsStorage$recom3 === void 0 ? void 0 : _rewardsStorage$recom3.redeemOptions) || [];
                allRewardIds = redeemOptions.reduce(function (ids, option) {
                  var rewardsApplied = (option === null || option === void 0 ? void 0 : option.rewardsApplied) || [];
                  var optionRewardIds = rewardsApplied.map(function (reward) {
                    return reward.rewardId;
                  });
                  return [].concat(_toConsumableArray(ids), _toConsumableArray(optionRewardIds));
                }, []);
                availableRewardsAux = _toConsumableArray(new Set([].concat(_toConsumableArray(availableRewardsAux), _toConsumableArray(allRewardIds))));
                setAvailablePegRewards(highestDiscountOption.pegsToRedeem);
              } else {
                setAvailablePegRewards((rewardsStorage === null || rewardsStorage === void 0 ? void 0 : (_rewardsStorage$rewar = rewardsStorage.rewardsRedemptionResponse) === null || _rewardsStorage$rewar === void 0 ? void 0 : (_rewardsStorage$rewar2 = _rewardsStorage$rewar.redeemOptions) === null || _rewardsStorage$rewar2 === void 0 ? void 0 : (_rewardsStorage$rewar3 = _rewardsStorage$rewar2[0]) === null || _rewardsStorage$rewar3 === void 0 ? void 0 : _rewardsStorage$rewar3.pegsRedeemed) || 0);
              }

              _context4.next = 21;
              break;

            case 14:
              recommendedRewardsRedemption = (rewardsStorage === null || rewardsStorage === void 0 ? void 0 : rewardsStorage.rewardsRedemptionResponse) || null;
              recommendedPointsToRedeem = (recommendedRewardsRedemption === null || recommendedRewardsRedemption === void 0 ? void 0 : (_recommendedRewardsRe = recommendedRewardsRedemption.redeemOptions) === null || _recommendedRewardsRe === void 0 ? void 0 : (_recommendedRewardsRe2 = _recommendedRewardsRe[0]) === null || _recommendedRewardsRe2 === void 0 ? void 0 : _recommendedRewardsRe2.totalPointsRedeemed) || 0;
              _context4.next = 18;
              return props.rewardsRedemption([], (rewardsStorage === null || rewardsStorage === void 0 ? void 0 : (_rewardsStorage$userP = rewardsStorage.userPegs) === null || _rewardsStorage$userP === void 0 ? void 0 : _rewardsStorage$userP.toString()) || '0', '', null);

            case 18:
              customRewardRedemption = _context4.sent;
              maxPegPointsToRedeem = (customRewardRedemption === null || customRewardRedemption === void 0 ? void 0 : (_customRewardRedempti9 = customRewardRedemption.redeemOptions) === null || _customRewardRedempti9 === void 0 ? void 0 : (_customRewardRedempti10 = _customRewardRedempti9[0]) === null || _customRewardRedempti10 === void 0 ? void 0 : _customRewardRedempti10.totalPointsRedeemed) || 0;
              setAvailablePegRewards(maxPegPointsToRedeem > recommendedPointsToRedeem ? maxPegPointsToRedeem : recommendedPointsToRedeem);

            case 21:
              setAvailableRewards(availableRewardsAux);
              _context4.next = 27;
              break;

            case 24:
              _context4.prev = 24;
              _context4.t0 = _context4["catch"](1);
              console.error('error', _context4.t0.message);

            case 27:
            case "end":
              return _context4.stop();
          }
        }
      }, _callee4, null, [[1, 24]]);
    }))();
  }, [show, releaseRedemptionEngineV2]);
  useEffect(function () {
    if (selectedValues && show) {
      setConfigChanged(true);
    }
  }, [selectedValues]);
  useEffect(function () {
    if (!show) {
      var _props$rewardsState;

      var redeemedRewards = ((_props$rewardsState = props.rewardsState) === null || _props$rewardsState === void 0 ? void 0 : _props$rewardsState.redeemedRewards) || null;

      if (redeemedRewards) {
        setSelectedValues(_objectSpread({}, redeemedRewards));
      }

      setConfigChanged(false);
    }
  }, [show, (_props$rewardsState2 = props.rewardsState) === null || _props$rewardsState2 === void 0 ? void 0 : _props$rewardsState2.redeemedRewards]);
  useEffect(function () {
    if (['recommended', 'custom'].includes(moduleType)) {
      var _props$rewardsState3, _props$rewardsState4, _props$rewardsState5, _rewardsResponse$rede, _rewardsResponse$rede2;

      var redeemedRewards = ((_props$rewardsState3 = props.rewardsState) === null || _props$rewardsState3 === void 0 ? void 0 : _props$rewardsState3.redeemedRewards) || null;
      var rewardsResponse = (redeemedRewards === null || redeemedRewards === void 0 ? void 0 : redeemedRewards.type) === 'recommended' ? (_props$rewardsState4 = props.rewardsState) === null || _props$rewardsState4 === void 0 ? void 0 : _props$rewardsState4.rewardsRedemptionResponse : (_props$rewardsState5 = props.rewardsState) === null || _props$rewardsState5 === void 0 ? void 0 : _props$rewardsState5.customRewardsRedemptionResponse;
      var totalDiscountAmount = (rewardsResponse === null || rewardsResponse === void 0 ? void 0 : (_rewardsResponse$rede = rewardsResponse.redeemOptions) === null || _rewardsResponse$rede === void 0 ? void 0 : (_rewardsResponse$rede2 = _rewardsResponse$rede[0]) === null || _rewardsResponse$rede2 === void 0 ? void 0 : _rewardsResponse$rede2.totalDiscountAmount) || 0;

      if (releaseRedemptionEngineV2) {
        var _rewardsResponse$rede3, _rewardsResponse$rede4;

        totalDiscountAmount = (rewardsResponse === null || rewardsResponse === void 0 ? void 0 : (_rewardsResponse$rede3 = rewardsResponse.redeemOptions) === null || _rewardsResponse$rede3 === void 0 ? void 0 : (_rewardsResponse$rede4 = _rewardsResponse$rede3[0]) === null || _rewardsResponse$rede4 === void 0 ? void 0 : _rewardsResponse$rede4.totalDiscountAmt) || 0;
      }

      if (redeemedRewards) {
        setSelectedValues(_objectSpread({}, redeemedRewards));
      } else {
        setSelectedValues(null);
      }

      setRewardsValue(totalDiscountAmount);
    }
  }, [(_props$rewardsState6 = props.rewardsState) === null || _props$rewardsState6 === void 0 ? void 0 : _props$rewardsState6.redeemedRewards, moduleType]);

  var hideError = function hideError() {
    setErrorState({
      show: false,
      action: null
    });
  };

  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(RewardsUpdatingOverlay, {
    show: showOverlay
  }), /*#__PURE__*/React.createElement(RewardSelectionModalError, {
    model: errorModel,
    show: errorState.show,
    action: errorState.action,
    hide: hideError,
    handleRefresh: handleRefresh,
    handleApplyRewards: handleApplyRewards
  }), /*#__PURE__*/React.createElement(Modal, {
    className: 'reward-selection-modal',
    show: show,
    hide: hide,
    hideCloseButton: false,
    backdrop: false,
    size: 'lg'
  }, /*#__PURE__*/React.createElement("div", {
    className: 'reward-selection-modal__container container'
  }, /*#__PURE__*/React.createElement("button", {
    className: "reward-selection-modal__close",
    onClick: hide
  }, /*#__PURE__*/React.createElement(IoMdClose, null)), /*#__PURE__*/React.createElement("div", {
    className: 'reward-selection-modal__body'
  }, /*#__PURE__*/React.createElement("div", {
    className: 'reward-selection-modal__logo-container'
  }, /*#__PURE__*/React.createElement(ImageLoader, {
    media: Logo,
    className: "reward-selection-modal__logo"
  })), /*#__PURE__*/React.createElement("div", {
    className: 'reward-selection-modal__listings'
  }, /*#__PURE__*/React.createElement(RewardsRecommendationListing, {
    rewardsState: props.rewardsState,
    model: RecomendationListing === null || RecomendationListing === void 0 ? void 0 : RecomendationListing[0].fields,
    bonusRewards: bonusRewards,
    availableRewards: availableRewards,
    selectedValues: selectedValues,
    setSelectedValues: setSelectedValues,
    releaseRedemptionEngineV2: releaseRedemptionEngineV2,
    rewardBadge: rewardBadge,
    unavailableRewardCopy: unavailableRewardCopy
  }), /*#__PURE__*/React.createElement(PegRedemptionCardListing, {
    model: PegRedemptionCardsList === null || PegRedemptionCardsList === void 0 ? void 0 : PegRedemptionCardsList[0].fields,
    availablePegRewards: availablePegRewards,
    selectedValues: selectedValues,
    setSelectedValues: setSelectedValues
  })), /*#__PURE__*/React.createElement("div", {
    className: 'reward-selection-modal__buttons-container'
  }, !configChanged ? /*#__PURE__*/React.createElement("span", {
    className: 'reward-selection-modal__buttons-container__rewards-value'
  }, "".concat((_model$RewardValueLa = model['Reward ValueLabel']) === null || _model$RewardValueLa === void 0 ? void 0 : (_model$RewardValueLa$ = _model$RewardValueLa.value) === null || _model$RewardValueLa$ === void 0 ? void 0 : _model$RewardValueLa$.replace('<#Amount>', rewardsValue))) : /*#__PURE__*/React.createElement("span", {
    className: 'reward-selection-modal__buttons-container__refresh-rewards-value',
    onClick: handleRefresh
  }, RefreshLabel === null || RefreshLabel === void 0 ? void 0 : RefreshLabel.value), /*#__PURE__*/React.createElement(Button, {
    className: 'cb-button-primary reward-selection-modal__buttons-container__apply-rewards-btn',
    onClick: handleApplyRewards
  }, ApplyButton === null || ApplyButton === void 0 ? void 0 : ApplyButton.value))))));
};

export default RewardSelectionModal;